import { useNavigate } from "react-router-dom";
import QuoteFilters from "./QuoteFilters";
import QuoteTable from "./QuoteTable";
import QuotePagination from "./QuotePagination";
import { useQuotes } from "../../hooks/useQuotes";

export default function QuoteList() {
  const navigate = useNavigate();

  const {
    quotes,
    loading,
    fromDate,
    toDate,
    searchCode,
    currentPage,
    totalPages,
    total,
    from,
    to,
    setFromDate,
    setToDate,
    setSearchCode,
    handlePageChange,
    handleSearch,
    handleClearFilters,
    handleSearchByCode,
    handleClearCode,
    handleDownloadPdf,
    handleDelete,
  } = useQuotes();

  return (
    <div className="invoice-list-container">
      <div className="card">
        {/* Header */}
        <div className="card-header">
          <h2 className="card-title">🧾 Cotizaciones</h2>

          <button
            className="btn btn-primary"
            onClick={() => navigate("/quotes/nueva")}
          >
            ➕ Nueva Cotización
          </button>
        </div>

        <div className="card-body">
          {/* Filtros */}
          <QuoteFilters
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            onSearch={handleSearch}
            onClear={handleClearFilters}
            searchCode={searchCode}
            setSearchCode={setSearchCode}
            onSearchByCode={handleSearchByCode}
            onClearCode={handleClearCode}
          />

          {/* Información de resultados */}
          <div className="results-info">
            <p>
              Mostrando <strong>{from} - {to}</strong> de <strong>{total}</strong> cotizaciones
            </p>
          </div>

          {/* Tabla */}
          <QuoteTable
            quotes={quotes}
            loading={loading}
            onDownloadPdf={handleDownloadPdf}
            onDelete={handleDelete}
            onClearFilters={handleClearFilters}
            hasFilters={!!(fromDate || toDate || searchCode)}
          />

          {/* Paginación */}
          {!loading && (
            <QuotePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
}